import React, {useEffect, useState} from 'react';
import {StyleSheet, TouchableOpacity, View, Text, TextInput} from 'react-native';
import {CountryPicker} from 'react-native-country-codes-picker';
import {useSelector} from 'react-redux';
import {globalFontStyle} from '../../../assets';
import Colors from '../../../assets/Color/Colors';
import Width from '../../../assets/Width';
import {globalImport} from '../../../common/globalImports';
import {Button} from '../../../components/core/Button';
import {isMobile} from '../../../utils/commonMethods';
import {Network} from '../../../utils/network';
import {globalConfigurableData} from '../../../utils/globalConstant';

const CountrySelection = ({onCountrySelect}) => {
  const globalConfigData = useSelector(
    state => state.utilReducer.globalConfigData,
  );
  const [show, setShow] = useState(false);
  const [countryList, setCountryList] = useState([]);
  const [country, setCountry] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    const tempList = [];
    globalConfigData?.countries?.map(data => {
      tempList.push(data?.iso_code);
    });
    setCountryList(tempList);
  }, [globalConfigData]);

  const handleSubmit = async () => {
    if (!country) {
      setError('Please select a country');
      return;
    }
    
    try {
      // Call getConfig with selected country
      // const response = await Network.getConfig({
      //   headers: {
      //     country: country.code
      //   }
      // });
      
      // if (response?.data) {
      onCountrySelect(country);
      // }
    } catch (err) {
      setError('Something went wrong. Please try again.');
    }
  };

  return (
    <View style={styles.container}>
      <View style={styles.headerContainer}>
        <Text style={styles.headerTitle}>Select Your Country</Text>
        <Text style={styles.headerSubtext}>
          Please select your country to continue
        </Text>
      </View>

      <View style={styles.inputContainer}>
        <Text style={styles.labelStyles}>Your Country</Text>
        <TouchableOpacity
          activeOpacity={0.9}
          onPress={() => setShow(true)}>
          <View style={{
            backgroundColor: globalConfigurableData.cardBgColor,
            borderRadius: 8,
            borderWidth: 1,
            overflow: 'hidden',
            borderColor: error ? Colors.red : globalConfigurableData.borderColor,
          }}>
            <TextInput
              placeholder="Select Country"
              value={country?.name?.en || ''}
              style={{
                height: 46,
                paddingHorizontal: 16,
                color: globalConfigurableData.primaryTextColor1,
                backgroundColor: 'transparent',
                borderWidth: 0,
              }}
              editable={false}
              pointerEvents="none"
            />
          </View>
        </TouchableOpacity>
        {error && (
          <Text style={styles.errorText}>{error}</Text>
        )}

        {countryList.length > 0 && (
          <CountryPicker
            style={{
              modal: styles.modalPicker,
              flag: {borderRadius: 50},
              textInput: {
                height: 50,
              },
              countryButtonStyles: {
                borderRadius: 8,
                marginTop: 5,
                flex: 1,
              },
              backdrop: {
                backgroundColor: Colors.bgWhite,
                opacity: 0,
              },
            }}
            show={show}
            pickerButtonOnPress={item => {
              setCountry(item);
              setError('');
              setShow(false);
            }}
            showOnly={countryList}
            onBackdropPress={() => setShow(false)}
            lang={'en'}
            inputPlaceholder={'Type your country or code'}
          />
        )}
      </View>

      <View style={{paddingVertical: 30}}>
        <Button
          variant="primary"
          onPress={handleSubmit}
          style={{flex: globalImport.isWeb ? {} : 0, marginTop: 15}}
          disabled={!country}
        >
          Continue
        </Button>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    marginTop: 50,
  },
  inputContainer: {
    marginBottom: 16,
  },
  errorText: {
    ...globalFontStyle.appFontSmallText,
    color: '#FF0000',
    marginTop: 4,
    marginLeft: 2,
  },
  labelStyles: {
    color: globalConfigurableData.secondaryTextColor1,
    ...globalFontStyle.appFontBody,
    fontSize: 13,
    fontWeight: '400',
    marginLeft: 2,
    marginBottom: 4,
    opacity: 0.8,
    textAlign: 'left',
  },
  modalPicker: {
    shadowColor: 'rgba(34, 48, 73, 0.2)',
    shadowOpacity: 66,
    position: 'absolute',
    top: 230,
    shadowRadius: 66,
    shadowOffset: {width: 20, height: 20},
    height: isMobile() ? 500 : 400,
    width: 300,
    borderRadius: 8,
    left: isMobile() ? 15 : Width.width / 2 + 15,
    backgroundColor: Colors.bgWhite,
  },
  headerContainer: {
    marginBottom: 32,
  },
  headerTitle: {
    ...globalFontStyle.appFontEventTitle,
    fontSize: 24,
    fontWeight: '600',
    color: globalConfigurableData.primaryTextColor1,
    marginBottom: 8,
  },
  headerSubtext: {
    ...globalFontStyle.appFontSubText,
    fontSize: 14,
    lineHeight: 20,
    color: globalConfigurableData.secondaryTextColor1,
    opacity: 0.8,
  },
});

export default CountrySelection; 